// extracted by mini-css-extract-plugin
export var serviceContent = "index-module--serviceContent--533ff";
export var serviceDescription = "index-module--serviceDescription--d531b";
export var serviceHeading = "index-module--serviceHeading--11c5c";
export var serviceTitle = "index-module--serviceTitle--f64f2";